module.exports = __webpack_public_path__ + "img/3.ac4e9b28.jpg";